import React, { FunctionComponent } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { FindADealerModel } from '../models/findDealer.model';
import CTAButton, { ctaEnums } from '../../@shared/ctaButton';
import Icon from '../../@shared/icon';

const LocatorForm: FunctionComponent<{ model: FindADealerModel }> = ({ model }) => (
  <>
    <form className="find-a-dealer__form" action={model.searchUrl}>
      <div className="find-a-dealer__input-wrapper find-a-dealer__input-wrapper--address">
        <Icon iconName="action-search" extraClassName="find-a-dealer__input-icon" size={24} />
        <input name={'address'} placeholder={model.inputPlaceholderText} className="find-a-dealer__input" />
      </div>
      <CTAButton type={ctaEnums.primaryRed}>
        <button type="submit" className="find-a-dealer__cta find-a-dealer__cta--submit">
          {model.searchButtonText}
        </button>
      </CTAButton>
    </form>
    <CTAButton type={ctaEnums.primaryWhite}>
      <button type="button" className="find-a-dealer__cta find-a-dealer__cta--locate-me">
        {model.locateMeButton && <Text field={model.locateMeButton} />}
      </button>
    </CTAButton>
  </>
);

export default LocatorForm;
